<div class="pageheader">
    <div class="page-title">
        <h1>Change log</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="search.refresh()">
                <span>Refresh</span>
                <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
        </div>
    </div>
</div>
<app-change-log-search #search>
    <app-change-log-viewer [items]="search.items" [users]="search.users"></app-change-log-viewer>
</app-change-log-search>
